/* eslint-disable react/prefer-stateless-function */
import React, { Component, useEffect } from 'react';
import {
  HomeNewsMetaTags,
  HomeReviewMetaTags,
  HomeAnalyticsMetaTags,
} from 'services/metaTags';
import { Link, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import ChannelPage from 'routes/Portfolio/Component/ChannelPage/ChannelPage.js';
import AnalyticsSection from './AnalyticsSection/AnalyticsSection';
import CommunitySection from './CommunitySection/CommunitySection';
import HeroImage from './HeroImage.png';
import FooterImage from './FooterImage.png';
import './LoggedOutPage.scss';

const URLSearchParams = require('url-search-params');

class LoggedOutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      section: this.props.feature,
    };
    this.referrerPage = 'averpoint-logged-out-page';
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.feature !== prevProps.feature)
      this.setState({
        section: this.props.feature,
      });
  };

  setRoleType = (roleType) => {
    this.setState({ roleType });
  };

  linkToSection = (child, to, className = '') => {
    return (
      <Link to={to} className={className}>
        {child}
      </Link>
    );
  };

  button = (text, icon, to, className = '') =>
    this.linkToSection(
      <RectangularButton
        className={`light-blue button ${className}`}
        iconName={icon}
        iconSize={24}
      >
        {text}
      </RectangularButton>,
      to,
    );

  renderFooter = () => (
    <div className="footer-section">
      <div className="footer-container">
        <div className="footer-text">Start reading better today!</div>
        <div className="footer-sub-text">
          Sign up today and let’s restore a society grounded in substance and
          truth.
        </div>
        <Link to={`/auth/signUp?referrer=${this.referrerPage}`}>
          <RectangularButton className="footer-button">
            Sign Up
          </RectangularButton>
        </Link>
      </div>
      <img src={FooterImage} />
    </div>
  );

  renderNewsSection = () => (
    <React.Fragment>
      <HomeNewsMetaTags />
      <div className="container">
        {/* <div className="hint">
          <div>
            The <b>AverPoint channel</b> helps you read from a wider range of
            sources, topics, and places.
          </div>
          <Link
            to={`/auth/signUp?referrer=${this.referrerPage}`}
            className="link-blue"
          >
            Sign up
          </Link>{' '}
          to get suggestions based on what you’re reading.
        </div> */}
      </div>
      <ChannelPage />
    </React.Fragment>
  );

  renderAnalyticsSection = () => (
    <React.Fragment>
      <HomeAnalyticsMetaTags />
      <div className="container">
        <div className="hint">
          Your <b>AverPoint Analytics</b> helps you better understand the news
          you're consuming on your phone. computer, and smart TV.
        </div>
      </div>
      <AnalyticsSection />
      <div className="container">{this.renderFooter()}</div>
    </React.Fragment>
  );

  renderCommunitySection = () => (
    <React.Fragment>
      <HomeReviewMetaTags />
      <div className="container">
        <div className="hint">
          The <b>Community Review</b> shows you how our members questioned and
          reviewed an article, helping you decide if you can trust an idea.
        </div>
      </div>
      <CommunitySection />
      <div className="container">{this.renderFooter()}</div>
    </React.Fragment>
  );

  renderSection = () => {
    switch (this.state.section) {
      case 'news':
        return this.renderNewsSection();
      case 'analytics':
        return this.renderAnalyticsSection();
      case 'review':
        return this.renderCommunitySection();
    }
  };

  render() {
    if (this.props.isAuthenticated) {
      const focusPointId = this.props.focusPointId;
      const queryParams = focusPointId ? `pointId=${focusPointId}` : '';

      return (
        <Redirect
          to={{
            pathname: '/portfolio',
            search: queryParams,
          }}
        />
      );
    }

    return (
      <div className="logged-out-page">
        <div className="section-header">
          <div className="container">
            <Row>
              <Col sm={8}>
                <div className="header">
                  {/* <div>A news app that inspires and empowers an informed society.</div> */}
                  <div>
                  A news app that empowers informed citizens in the age of disinformation.
                  </div>
                </div>
                <div className="description my-3">
                  <div className="description-text">
                    Conscious reading. Critical thinking. Informed discussions.
                    {/* <ul>
                      <li>Conscious reading</li>
                      <li>Critical thinking</li>
                      <li>Informed discussions</li>
                    </ul> */}
                    {/* <br />
                    <span className="font-weight-bold">
                      <Link to={`/auth/signUp?referrer=${this.referrerPage}`} className="link-white">
                        Sign up
                      </Link>{' '}
                    </span>
                    now to get: */}
                  </div>
                  {/* <ul className="mt-3 feature-points">
                    <li>
                      {this.linkToSection(
                        <b>High quality news</b>,
                        '/home/news',
                        'link-white',
                      )}{' '}
                      that broadens and deepens your understanding of our
                      complex world
                    </li>
                    <li>
                      {this.linkToSection(
                        <b>Analytics</b>,
                        '/home/analytics',
                        'link-white',
                      )}{' '}
                      so you can understand and improve your news consumption
                    </li>
                    <li>
                      {this.linkToSection(
                        <b>Community review</b>,
                        '/home/review',
                        'link-white',
                      )}{' '}
                      that helps you evaluate if an idea is trustworthy
                    </li>
                  </ul> */}
                </div>
                <div className="actions mt-4 mb-4">
                  {this.button(
                    'Sign Up',
                    '',
                    `/auth/signUp?referrer=${this.referrerPage}`,
                    'signUpButton',
                  )}
                  {this.linkToSection(
                    <b>Learn More</b>,
                    '/home/readers',
                    'link-white ml-4',
                  )}
                </div>
              </Col>

              {/* <Col sm={4} className="hero-image">
                <img src={HeroImage} />
              </Col> */}
            </Row>
          </div>
        </div>
        <div className="content-section">{this.renderSection()}</div>
        {/* <div className="mobile-buttons">
          {this.button('High quality news', 'PLAY', '/home/news', 'linkButton')}
          {this.button(
            'Analytics',
            'ACTIVITY',
            '/home/analytics',
            'linkButton',
          )}
          {this.button(
            'Community review',
            'COPY',
            '/home/review',
            'linkButton',
          )}
        </div> */}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.user.authenticated,
  };
}

function mapPropsToDispatch(dispatch, ownProps) {
  let focusPointId = null;

  try {
    const searchParams = new URLSearchParams(ownProps.location.search);

    focusPointId = searchParams.get('pointId') || null;
  } catch (error) {
    console.error('Error while getting query param');
  }

  const feature = ownProps.match.params.feature || 'news';
  return {
    feature,
    focusPointId,
  };
}

export default withRouter(
  connect(mapStateToProps, mapPropsToDispatch)(LoggedOutPage),
);
